import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './modal.scss';

import closeIcon from '../../assets/images/close.svg';
import { joinClasses } from '../../utils/helpers';

/** @import { ModalProps } from './ModalTypes' */

const findOrCreateModalRoot = () => {
  let modalRoot = document.getElementById('modal-root');
  if (!modalRoot) {
    modalRoot = document.createElement('div');
    modalRoot.id = 'modal-root';
    document.body.appendChild(modalRoot);
  }
  return modalRoot;
};

/** @extends {Component<ModalProps>} */
class Modal extends Component {

  modalRoot = findOrCreateModalRoot();
  el = document.createElement('div');

  componentDidMount() {
    this.modalRoot.appendChild(this.el);
    this.modalRoot.classList.add('modal-is-open');

    if (this.props.mobileOptimised) {
      this.modalRoot.classList.add('modal-mobile-optimised');
    }
    else {
      this.modalRoot.classList.remove('modal-mobile-optimised');
    }
  }

  componentWillUnmount() {
    this.modalRoot.removeChild(this.el);
    this.modalRoot.classList.remove('modal-is-open');
  }

  renderModal() {
    const { onClose, className, children, hideClose } = this.props;
    return (
      <div className='modal-container'>
        <section
          className={joinClasses('modal', className)}
          onClick={e => e.stopPropagation()}
        >
          <div className='modal__close'>
            {!hideClose && <img src={closeIcon} onClick={onClose} />}
          </div>
          <div className='modal__content'>
            {children}
          </div>
        </section>
      </div>
    );
  }

  render() {
    return ReactDOM.createPortal(
      this.renderModal(),
      this.el,
    );
  }
}

export default Modal;
